import React, { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { MenuItem } from '@mui/material';
import CustomSelect from '../../../../../components/common/SelectField';


interface IProps {
  moduleData: any;
  isView: boolean;
  process: any;
  index: number;

}


const TBodyRow = ({
  moduleData,
  isView,
  process,
  index,
}: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <React.Fragment key={index + 10.1 + 'heading '}>
      <tr>
        <th style={{ minWidth: '50px', textAlign: 'center' }}>
          {process?.sNo}
        </th>
        <th style={{ minWidth: '150px', textAlign: 'center' }}>
          {process?.area_of_process}
        </th>
        <th style={{ minWidth: '200px', textAlign: 'center' }}>
        {process?.area_of_functions}
        </th>
        <th style={{ minWidth: '150px', textAlign: 'center' }}>
          {process?.avg_noise_db}
        </th>
        {['apr','may','jun','jul','aug','sep','oct','nov','dec','jan','feb','mar','remarks'].map((month)=>{
          return (
            <td style={{ minWidth: '100px', textAlign: 'center' }}>
            <TableInput
                isView={isView}
                name={month}
                type="text"
                value={process?.[month]}
                onChange={(e) => {
                  handleChangeModuleData(e, process);
                  // process[month] = e.target.value;
                  setRender((prev) => !prev);
                }}
              />
              </td>
          )
        })}
      </tr>
    </React.Fragment>
  );
};

export default TBodyRow;
